export const contentList = {
  title: 'Mis Contenidos',
  subtitle: '{{count}} contenidos',
  subtitleSingular: '1 contenido',
  newContent: 'Nuevo contenido',
  search: {
    placeholder: 'Buscar por título o keyword...',
  },
  findReplace: {
    toggle: 'Buscar y reemplazar',
    searchPlaceholder: 'Término a buscar...',
    replacePlaceholder: 'Reemplazar por...',
    matchCase: 'Distinguir mayúsculas',
    replace: 'Reemplazar',
    replaceCurrentAriaLabel: 'Reemplazar la coincidencia actual',
    replaceAll: 'Reemplazar todo',
    counter: '{{current}}/{{total}}',
    previousMatch: 'Coincidencia anterior',
    nextMatch: 'Coincidencia siguiente',
    close: 'Cerrar',
    noMatches: 'Sin coincidencias',
    replacedToast: 'Se reemplazaron {{occurrences}} coincidencias',
  },
  filters: {
    statusPlaceholder: 'Filtrar por estado',
    all: 'Todos los estados',
    tagPlaceholder: 'Filtrar por tags',
    tagsSelected: '{{count}} tags',
    clearTags: 'Limpiar tags',
    sortPlaceholder: 'Ordenar por',
    sortNewest: 'Más recientes',
    sortOldest: 'Más antiguos',
    sortTitle: 'Título A-Z',
  },
  folders: {
    sectionTitle: 'Carpetas',
    itemCount: '{{count}} elementos',
    itemCountSingular: '1 elemento',
    emptyFolder: 'Esta carpeta está vacía',
    emptyFolderDescription: 'Mueve contenido aquí o crea contenido nuevo',
    createFolder: 'Nueva carpeta',
    rename: 'Renombrar',
    delete: 'Eliminar',
    deleteConfirmTitle: '¿Eliminar carpeta?',
    deleteConfirmDescription: 'Los contenidos dentro de esta carpeta no serán eliminados, quedarán sin organizar.',
    renameTitle: 'Renombrar carpeta',
    renamePlaceholder: 'Nombre de la carpeta',
    renameConfirm: 'Renombrar',
    folder: 'Carpeta',
    item: 'elemento',
    items: 'elementos',
  },
  breadcrumb: {
    allContents: 'Todos los Contenidos',
  },
  selection: {
    itemsSelected: '{{count}} seleccionados',
    selectAll: 'Seleccionar todos',
    deselectAll: 'Deseleccionar todos',
    moveToFolder: 'Mover a carpeta',
    removeFromFolder: 'Quitar de carpeta',
    moveSuccess: 'Contenidos movidos correctamente',
    removeSuccess: 'Contenidos removidos de la carpeta',
    moveError: 'Error al mover contenidos',
    addTags: 'Agregar tags',
    removeTags: 'Quitar tags',
    bulkAddTags: 'Agregar tags a seleccionados',
    bulkRemoveTags: 'Quitar tags de seleccionados',
    bulkAddTagsDescription: 'Selecciona tags para agregar a todos los contenidos seleccionados',
    bulkRemoveTagsDescription: 'Selecciona tags para quitar de todos los contenidos seleccionados',
    addTagsConfirm: 'Agregar tags',
    removeTagsConfirm: 'Quitar tags',
    tagsSelectedCount: '{{count}} tags seleccionados',
    addTagsSuccess: 'Tags agregados correctamente',
    removeTagsSuccess: 'Tags removidos correctamente',
    tagsError: 'Error al actualizar tags',
  },
  moveDialog: {
    title: 'Mover a carpeta',
    searchPlaceholder: 'Buscar carpetas...',
    noFolders: 'Sin carpetas aún',
    createNewFolder: 'Crear nueva carpeta',
    confirm: 'Mover',
    cancel: 'Cancelar',
  },
  viewMode: {
    grid: 'Vista grilla',
    table: 'Vista tabla',
  },
  table: {
    columns: {
      title: 'Título',
      keyword: 'Keyword',
      status: 'Estado',
      entity: 'Entidad',
      date: 'Fecha',
      actions: 'Acciones',
    },
  },
  status: {
    generating: 'Generando',
    completed: 'Completado',
    failed: 'Error',
  },
  time: {
    justNow: 'Ahora',
    minutesAgo: 'hace {{minutes}}m',
    hoursAgo: 'hace {{hours}}h',
    daysAgo: 'hace {{days}}d',
  },
  actions: {
    open: 'Abrir',
    delete: 'Eliminar',
    moveToFolder: 'Mover a carpeta',
  },
  empty: {
    title: 'Sin contenidos aún',
    description:
      'Comienza generando tu primer contenido optimizado para SEO y GEO con inteligencia artificial.',
    createButton: 'Crear contenido',
  },
  error: {
    title: 'Error al cargar',
    description: 'No pudimos cargar tus contenidos. Intenta de nuevo.',
  },
  pagination: {
    previous: 'Anterior',
    next: 'Siguiente',
    pageOf: 'Página {{page}} de {{totalPages}}',
    showing: 'Mostrando {{from}}-{{to}} de {{total}}',
  },
  deleteConfirm: {
    title: '¿Eliminar contenido?',
    description:
      'Esta acción no se puede deshacer. El contenido y todas sus versiones serán eliminados permanentemente.',
    cancel: 'Cancelar',
    confirm: 'Eliminar',
    success: 'Contenido eliminado correctamente',
    error: 'Error al eliminar el contenido',
  },
  tabs: {
    close: 'Cerrar pestaña',
    newTab: 'Abrir otro contenido',
    searchPlaceholder: 'Buscar contenido...',
    empty: 'No hay contenidos para abrir',
    noResults: 'Sin resultados para "{{search}}"',
    alreadyOpen: 'Ya abierto',
    noFolder: 'Sin carpeta',
  },
  detail: {
    title: 'Detalle del Contenido',
    backToList: 'Volver al listado',
    notFound: {
      title: 'Contenido no encontrado',
      description: 'El contenido que buscas no existe o fue eliminado.',
    },
    generating: {
      title: 'Generando contenido...',
      description: 'El contenido está siendo procesado. Esta página se actualizará automáticamente.',
    },
    generationError: {
      title: 'Error en la generación',
    },
    generatedSuccess: 'Contenido generado correctamente!',
    regeneratingFromInput: 'Regenerando contenido desde el input original...',
    titleUpdateSuccess: 'Título actualizado',
    titleUpdateError: 'Error al actualizar título: {{message}}',
    improve: 'Mejorar',
    improving: 'Mejorando...',
    tabs: {
      content: 'Contenido',
    },
    seoScore: {
      criteriaToImprove: '{{count}} criterios por mejorar',
      allPassed: 'Todos los criterios aprobados',
      showDetail: 'Ver detalle',
      hideDetail: 'Ocultar detalle',
    },
    showLess: 'Ver menos',
    sections: {
      brief: 'Brief',
      contentInfo: 'Información del Contenido',
      seoVerification: 'Verificación',
      reliability: 'Fiabilidad del Contenido',
    },
    references: {
      internal: 'Internas',
      external: 'Externas',
    },
    fields: {
      mainEntity: 'Entidad Principal',
      language: 'Idioma',
      brandVoice: 'Voz de Marca',
      viewBrandVoice: 'Ver voz de marca',
      references: 'Referencias',
      slug: 'Slug',
      seoTitle: 'Título SEO',
      metaDescription: 'Meta Descripción',
      geo: 'Geolocalización',
      lastUpdated: 'Última actualización:',
    },
    seoTabs: {
      seo: 'SEO',
      social: 'Social',
      schema: 'Schema',
    },
    imageGallery: {
      title: 'Imágenes',
      aiFallbackBadge: 'IA (stock no disponible)',
      stockFailedTitle: 'Stock no disponible',
      stockFailedDescription:
        'El proveedor de stock falló, así que no se agregaron imágenes a este contenido.',
      coverLabel: 'Imagen de portada',
      sectionLabel: 'Sección',
      regenerateTitle: 'Regenerar imagen',
      customPromptLabel: 'Instrucciones personalizadas (opcional)',
      customPromptPlaceholder: 'Ej: Usar tonos más cálidos, agregar más contraste...',
      regenerateButton: 'Regenerar',
      regenerating: 'Regenerando...',
      cancel: 'Cancelar',
      regenerateSuccess: 'Imagen regenerada correctamente',
      regenerateError: 'Error al regenerar imagen: {{message}}',
      generateNew: 'Nueva imagen',
      generateSuccess: 'Nueva imagen generada correctamente',
      generateError: 'Error al generar imagen: {{message}}',
      generating: 'Generando...',
      contextDialogTitle: 'Generar imagen para sección',
      contextDialogDescription: 'Selecciona la sección que la imagen va a ilustrar para que coincida con el contexto del contenido.',
      selectSection: 'Seleccionar una sección',
      customContext: 'O describe el contexto manualmente',
      customContextPlaceholder: 'Ej: Un gráfico comparativo de estrategias SEO vs GEO...',
      generateForSection: 'Generar imagen',
      generateAndInsert: 'Generar e insertar',
      insertInContent: 'Insertar en contenido',
      zoomLabel: 'Ampliar',
      regenerateLabel: 'Regenerar',
      deleteLabel: 'Eliminar imagen',
      deleteConfirmTitle: '¿Eliminar imagen?',
      deleteConfirmDescription: 'Esto eliminará la imagen del contenido. Esta acción no se puede deshacer.',
      deleteConfirm: 'Eliminar',
      deleteSuccess: 'Imagen eliminada correctamente',
      deleteError: 'Error al eliminar imagen: {{message}}',
      emptyTitle: 'Sin imágenes generadas',
      emptyDescription: 'La generación inicial no creó imágenes. Generá una nueva para ilustrar el contenido.',
    },
    seoMetadata: {
      updateSuccess: 'Metadatos SEO actualizados',
      updateError: 'Error al actualizar metadatos SEO: {{message}}',
    },
    export: {
      download: 'Descargar',
      loadingTags: 'Cargando tags...',
      htmlFull: 'HTML (completo)',
      json: 'JSON (estructurado)',
      htmlSimple: 'HTML (simple)',
    },
    editor: {
      save: 'Guardar',
      saving: 'Guardando...',
      saved: 'Contenido guardado correctamente',
      saveError: 'Error al guardar el contenido',
      unsavedChanges: 'Cambios sin guardar',
      richText: 'Texto enriquecido',
      markdown: 'Markdown',
    },
    languages: {
      es: 'Español',
      en: 'Inglés',
      pt: 'Portugués',
    },
    reliability: {
      analyzing: 'Analizando fiabilidad...',
      skipped: 'Sin fuentes para analizar',
      failed: 'El análisis falló',
      retry: 'Reintentar',
      analyze: 'Analizar',
      overallConfidence: 'Confianza General',
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
      internalSource: 'Fuente Interna',
      web: 'Web',
      inferred: 'Inferido',
      searchPlaceholder: 'Buscar afirmaciones...',
      filterAll: 'Todos',
      claimsCount: '{{count}} afirmaciones analizadas',
      viewDetails: 'Ver detalles',
      close: 'Cerrar',
      source: 'Fuente',
      confidence: 'Confianza',
      excerpt: 'Extracto de la fuente',
      articlePhrase: 'Artículo',
      sourcePhrase: 'Fuente',
      noSourceMatch: 'Sin coincidencia de fuente',
      fix: 'Corregir',
      fixAll: 'Corregir todos ({{count}})',
      fixing: 'Corrigiendo...',
      fixSuccess: '{{count}} afirmación(es) corregida(s) correctamente',
      fixNoData: 'No se encontraron datos para corregir',
      fixError: 'Error al corregir afirmaciones: {{message}}',
      fixStatusFixed: 'Corregido',
      fixStatusNoData: 'Sin datos',
      fixStatusUnchanged: 'Sin cambios',
      fixStatusError: 'Error',
    },
    tags: {
      addTag: 'Agregar tag',
      edit: 'Editar',
      searchTags: 'Buscar tags...',
      noTagsFound: 'Sin resultados',
      noTagsAvailable: 'Sin tags disponibles',
      createNewTag: 'Crear nuevo tag',
      tagNamePlaceholder: 'Nombre del tag',
      tagColor: 'Color:',
      cancel: 'Cancelar',
      create: 'Crear',
    },
    folder: {
      assign: 'Asignar carpeta',
      change: 'Cambiar carpeta',
      searchFolders: 'Buscar carpetas...',
      noFoldersFound: 'Sin resultados',
      noFoldersAvailable: 'Sin carpetas disponibles',
      createNewFolder: 'Crear nueva carpeta',
      folderNamePlaceholder: 'Nombre de la carpeta',
      folderColor: 'Color:',
      cancel: 'Cancelar',
      create: 'Crear',
    },
  },
} as const

